import { components } from '@features/shared/api/fastgames';

export type IPoolType = components['schemas']['PoolType'];
export const POOLS = [
  'Bullet1Plus0',
  'Blitz3Plus0',
  'Blitz3Plus2',
  'Blitz5Plus0',
  'Blitz5Plus3',
  'Rapid10Plus0',
  'Rapid10Plus5',
] as const satisfies readonly IPoolType[];
export type IPoolInfoDto = {
  pool: IPoolType;
  players: number;
};

export type ISide = 'white' | 'black' | 'none';
export type IRematchStatus = 'player' | 'opponent' | 'available' | 'none';

export type IFastGame = {
  /** Необходимые данные загружаются (токен) */
  isLoading: boolean;
  /** Игра закончена */
  isFinished: boolean;

  /** Id игры */
  gameId: string;
  /** Токен для авторизации анонимного игрока */
  customToken?: string;
  /** Ошибка получения токена */
  customTokenError?: boolean;

  // Реванш
  /** Временное окно для предложения/подтверждения реванша */
  rematchExpiration?: number;
  /** Белые предложили реванш */
  rematchWhite?: boolean;
  /** Черные предложили реванш */
  rematchBlack?: boolean;

  // Действия
  /** Отказаться от найденой игры */
  reject(): void;
  /** Запросить реванш для законченой игры */
  rematch(): void;
};

export const MAX_ACTIVE_FRIEND_GAMES = 5;
